import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { take, map, debounceTime } from 'rxjs/operators';
import { Intervallo, IIntervallo } from 'app/model/ambulatorio';
import { Giorno } from 'app/model/time';
import { NgbTimeStruct, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, ViewChildren, QueryList, ElementRef, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MeasureService } from 'app/measure.service';
import { Impostazioni } from 'app/model/impostazioni_agenda';

interface IUpdateRequest {
	intervallo: Intervallo,
	value: IIntervallo
}

@Component({
	selector: 'app-ambulatorio',
	templateUrl: './ambulatorio.html',
	styleUrls: ['./ambulatorio.css']
})
export class AmbulatorioComponent implements OnDestroy {

	private readonly aggiorna: (inizio: NgbTimeStruct, fine: NgbTimeStruct, nome: string) => void;
	private readonly subscription: Subscription;
	mobileView: boolean;

	constructor(
		measureService: MeasureService
	) {
		const updateQueue = new Subject<IUpdateRequest>();

		this.aggiorna = (inizio: NgbTimeStruct, fine: NgbTimeStruct, nome: string) => {
			const interval = { inizio: inizio, fine: fine, ambulatorio: nome };
			this.correct = this.validHours(interval);
			if (this.correct) {
				updateQueue.next({
					intervallo: this.intervalloSelezionato,
					value: interval
				});
			}
		};

		this.subscription = updateQueue.pipe(
			debounceTime(300),
		).subscribe(update =>
			update.intervallo.update(update.value)
		);

		this.mobileView = measureService.isMobile();
	}

	// BAU!
	//       __
	//  (___()'`;
	//  /,    /`
	//  \\"--\\
	@ViewChildren(NgbTimepicker, { read: ElementRef })
	set picker(value: QueryList<ElementRef>) {
		// Diciamo grazie ai tizi di bootstrap.
		for (let el of value.map(c => c.nativeElement as HTMLElement)) {
			let list = el.querySelectorAll(".btn-link");
			for (var i = 0; i < list.length; i++) {
				(list.item(i) as HTMLElement).tabIndex = -1;
			}
		}
	}

	@Input()
	generali: Impostazioni;

	private _ambulatorio: Giorno[];

	@Input()
	set ambulatorio(value: Giorno[]) {
		this._ambulatorio = value;
		this.peek = Observable.combineLatest(value).pipe(
			map(() => true),
			take(1)
		).toPromise();
	}

	get ambulatorio(): Giorno[] {
		return this._ambulatorio;
	}

	peek: Promise<boolean>;

	giorni = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

	correct = true;
	intervalloSelezionato: Intervallo;
	giorno: Giorno;

	select(giorno: Giorno, intervallo: Intervallo) {
		this.intervalloSelezionato = intervallo;
		this.giorno = giorno;
		intervallo.subscribe(slot => {
			if (slot.fine.hour === 0 && slot.fine.minute === 0) {
				slot.inizio.hour = this.generali.inizio_giornata.hour;
				slot.inizio.minute = this.generali.inizio_giornata.minute;
				slot.fine.hour = this.generali.fine_giornata.hour;
				slot.fine.minute = this.generali.fine_giornata.minute;
			}
		});
	}

	hide() {
		this.intervalloSelezionato = null;
		this.giorno = null;
	}

	delete(intervallo: Intervallo) {
		this.giorno.delete(intervallo);
		this.hide();
	}


	validHours(intervallo: IIntervallo) {
		return (intervallo.inizio.hour < intervallo.fine.hour) ||
			(
				(intervallo.inizio.hour === intervallo.fine.hour) &&
				(intervallo.inizio.minute < intervallo.fine.minute)
			);
	}

	check(intervallo: IIntervallo) {
		return this.validHours(intervallo);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/ambulatorio/ambulatorio.ts